/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import '../../App.css';
import 'react-pivottable/pivottable.css';
import './pivotSale.css';
import PivotGrid, { FieldChooser } from 'devextreme-react/pivot-grid';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.dark.compact.css';
import { Button, DatePicker } from 'antd';
import { Box, Fade } from '@mui/material';
import { GetListPivot } from '../../api/listPivot';
import { useEffect } from 'react';
import dayjs from 'dayjs';
import { GridLoader } from 'react-spinners';
import { useSelector } from 'react-redux';
import { localhost } from "../../server";
import axios from "axios";
import { ToastError } from "../../components/ToastSwal";
import { listPermission } from '../../constants';

const { RangePicker } = DatePicker;

const PivotSale = () => {
  const [isListValuePivot, setIsListValuePivot] = useState([]);
  const startOfMonth = dayjs().startOf('year');
  const endOfMonth = dayjs().endOf('year');
  const [loading, setLoading] = useState(true);
  const [valueDateFrom, setValueDateFrom] = useState();
  const [valueDateTo, setValueDateTo] = useState();
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [lsPermissions, setLsPermissions] = useState([]);
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);

  const fetchListDataPivot = () => {
    GetListPivot({
      date_from: startOfMonth.format('DD-MM-YYYY'),
      date_to: endOfMonth.format('DD-MM-YYYY'),
      type: '2'
    })
      .then(res => {
        setIsListValuePivot(res.data.message);
        setLoading(false);
      })
      .catch(err => {});
  };

  useEffect(() => {
    setLoading(true);
    fetchListDataPivot();

    if (userInfo) {
      // setIsSuperA(userInfo.is_superuser);
      const arrPermission = userInfo.permission.map((item, index) => {
        return item.name;
      });

      if (arrPermission !== undefined) {
        setLsPermissions([...arrPermission]);
      }
    }

  }, []);

  const convertToMonth = dateString => {
    const dateParts = dateString !== null && dateString.split('/');
    const month = parseInt(dateParts[1], 10);
    return month;
  };

  const convertToYear = dateString => {
    const dateParts = dateString !== null && dateString.split('/');
    const year = parseInt(dateParts[2], 10);
    return year;
  };

  const convertedData = isListValuePivot
    .filter(item => item['Close Date'] !== null)
    .map(item => ({
      ...item,
      'Close Date': convertToMonth(item['Close Date']),
      Year: convertToYear(item['Close Date'])
    }));

  const dataSource = {
    fields: [
      { dataField: 'Project Name', area: 'row', width: 200 },
      { dataField: 'Year', area: 'column' },
      { dataField: 'Close Date', area: 'column' },
      {
        dataField: 'Exchange Rate',
        summaryType: 'sum',
        customizeText: cellInfo => {
          return cellInfo.value !== 0 && cellInfo.value !== undefined ? cellInfo.value.toLocaleString() : '0';
        }
      },
      {
        dataField: 'Discount',
        summaryType: 'sum',
        customizeText: cellInfo => {
          return cellInfo.value !== 0 && cellInfo.value !== undefined ? cellInfo.value.toLocaleString() : '0';
        }
      },
      {
        dataField: 'Expected Revenue',
        summaryType: 'sum',
        customizeText: cellInfo => {
          return cellInfo.value !== 0 && cellInfo.value !== undefined ? cellInfo.value.toLocaleString() : '0';
        }
      },
      {
        dataField: 'Price Exchange',
        summaryType: 'sum',
        customizeText: cellInfo => {
          return cellInfo.value !== 0 && cellInfo.value !== undefined ? cellInfo.value.toLocaleString() : '0';
        }
      },
      {
        dataField: 'Project Amount',
        area: 'data',
        summaryType: 'sum',
        customizeText: cellInfo => {
          return cellInfo.value !== 0 && cellInfo.value !== undefined ? cellInfo.value.toLocaleString() : '0';
        }
      },
      {
        dataField: 'Quantity',
        summaryType: 'sum',
        customizeText: cellInfo => {
          return cellInfo.value !== 0 && cellInfo.value !== undefined ? cellInfo.value.toLocaleString() : '0';
        }
      },
      {
        dataField: 'Unit Price',
        summaryType: 'sum',
        customizeText: cellInfo => {
          return cellInfo.value !== 0 && cellInfo.value !== undefined ? cellInfo.value.toLocaleString() : '0';
        }
      }
    ],
    store: convertedData // Thay data bằng dữ liệu thực tế của bạn
  };

  const onChangeRangePicker = (month, dateString) => {
    setLoading(true);
    setValueDateFrom(dateString[0]);
    setValueDateTo(dateString[1]);
    GetListPivot({
      date_from: dateString[0],
      date_to: dateString[1],
      type: '2'
    })
      .then(res => {
        setIsListValuePivot(res.data.message);
        setLoading(false);
      })
      .catch(err => {});
  };
  const screenWindown1540px = window.screen.width <= 1540;

  // download File Pivot Sales With Token
  const downloadFilePivotSalesWithToken = async (token, filename) => {
    try {
      setLoadingDownload(!loadingDownload);
      const response = await axios.get(
        `${localhost}/api/export_pivot_sale?date_from=${
          valueDateFrom === undefined
            ? startOfMonth.format("DD-MM-YYYY")
            : valueDateFrom
        }&date_to=${
          valueDateTo === undefined
            ? endOfMonth.format("DD-MM-YYYY")
            : valueDateTo
        }`,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      URL.revokeObjectURL(blobUrl);
      document.body.removeChild(link);
      setLoadingDownload(false);
    } catch (error) {
      setLoadingDownload(false);
      ToastError.fire({
        icon: "error",
        title: "Download không thành công!",
      });
    }
  };

  // download Pivot-sale
  const downloadExcelPivotSale = () => {
    function get_cookie(cookie_name) {
      const value = "; " + document.cookie;
      const parts = value.split("; " + cookie_name + "=");
      if (parts.length > 1) return parts.pop().split(";").shift();
    }

    var uuid_value = get_cookie("token_qldt");
    const authToken = uuid_value;
    const filename = `pivot_sales${
      valueDateFrom === undefined
        ? startOfMonth.format("DD-MM-YYYY")
        : valueDateFrom
    }_${
      valueDateTo === undefined ? endOfMonth.format("DD-MM-YYYY") : valueDateTo
    }.xlsx`;

    downloadFilePivotSalesWithToken(authToken, filename);
  };


  // download Pivot-sale Full with token
  const downloadFilePivotSalesFullWithToken = async (token, filename) => {
    try {
      setLoadingDownload(!loadingDownload);
      const response = await axios.get(
        `${localhost}/api/export_pivot_sale_full?date_from=${
          valueDateFrom === undefined
            ? startOfMonth.format("DD-MM-YYYY")
            : valueDateFrom
        }&date_to=${
          valueDateTo === undefined
            ? endOfMonth.format("DD-MM-YYYY")
            : valueDateTo
        }`,
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      URL.revokeObjectURL(blobUrl);
      document.body.removeChild(link);
      setLoadingDownload(false);
    } catch (error) {
      setLoadingDownload(false);
      ToastError.fire({
        icon: "error",
        title: "Download không thành công!",
      });
    }
  };

  // download Pivot-sale Full
  const downloadExcelPivotSaleFull = () => {
    function get_cookie(cookie_name) {
      const value = "; " + document.cookie;
      const parts = value.split("; " + cookie_name + "=");
      if (parts.length > 1) return parts.pop().split(";").shift();
    }

    var uuid_value = get_cookie("token_qldt");
    const authToken = uuid_value;
    const filename = `pivot_sales_full${
      valueDateFrom === undefined
        ? startOfMonth.format("DD-MM-YYYY")
        : valueDateFrom
    }_${
      valueDateTo === undefined ? endOfMonth.format("DD-MM-YYYY") : valueDateTo
    }.xlsx`;

    downloadFilePivotSalesFullWithToken(authToken, filename);
  };

  return (
    <>
      <Box
        sx={{
          width: '96%',
          margin: '2% auto',
          display: "grid"
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <RangePicker
            picker="month"
            onChange={onChangeRangePicker}
            format={'DD-MM-YYYY'}
            allowClear={false}
            defaultValue={[startOfMonth, endOfMonth]}
            disabled={loading === true ? true : false}
          />
          {isListValuePivot.length > 0 && lsPermissions.includes("Download Data Pivot Sales") ? (
            <>
            <Button
              onClick={downloadExcelPivotSale}
              style={{
                // fontSize: "14px",
                color: '#fff',
                background: 'rgba(84, 101, 239, 1)',
                borderColor: 'rgba(84, 101, 239, 1)',
                marginLeft: 30
              }}
              >
              Download
            </Button>

            <Button
              // Add function to handle full download
              onClick={downloadExcelPivotSaleFull}
              style={{
                color: '#fff',
                background: 'rgba(84, 101, 239, 1)', 
                borderColor: 'rgba(84, 101, 239, 1)',
                marginLeft: 10
              }}
            >
              Download Full
            </Button>
          </>
          ) : null}
        </div>
        {loading === false ? (
          <PivotGrid
            dataSource={dataSource}
            id="sales"
            allowFiltering={true}
            allowSorting={true}
            allowSortingBySummary={true}
            height={'80vh'}
            showBorders={true}
            // style={screenWindown1540px === true ? { maxWidth: 1200 } : { maxWidth: 1600 }}
            onCellClick={e => {
              // const cellData = e.cellElement.textContent;
            }}
          >
            <FieldChooser dataSource={dataSource} enabled={true} height={400} />
          </PivotGrid>
        ) : null}
        {loading === true ? (
          <Fade in={loading} unmountOnExit>
            <div
              style={{
                width: '100%',
                height: '50vh',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                background: '#f5f5f5'
              }}
            >
              <div style={{ marginBottom: '10px' }}>
                <GridLoader color="#020f59" loading={true} size={10} />
              </div>
              <p style={{ fontSize: 20 }}>Loading...</p>
            </div>
          </Fade>
        ) : null}
      </Box>
    </>
  );
};

export default PivotSale;
